import { Route as PublicRoute } from 'react-router-dom';

import { PATH_NAME } from '../pathNames';
import { AlertsGenerated } from '../lazyLoaded';

const AlertsGeneratedRoute = () => (
  <PublicRoute
    exact
    path={PATH_NAME.ALERTS_GENERATED}
    component={(props: JSX.IntrinsicAttributes) => (
      <AlertsGenerated {...props} />
    )}
  />
);
export default AlertsGeneratedRoute;
